import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/auth/AuthProvider";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2, Award } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const Route = createFileRoute("/_authenticated/student/badges")({
  component: StudentBadges,
});

function StudentBadges() {
  const { user } = useAuth();
  const [badges, setBadges] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    async function loadBadges() {
      const { data } = await supabase
        .from("student_badges")
        .select("earned_at, badges(*)")
        .eq("student_id", user?.id || "");

      setBadges(data || []);
      setLoading(false);
    }
    loadBadges();
  }, [user]);

  if (loading)
    return (
      <div className="flex justify-center p-10">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-extrabold flex items-center gap-3">
        <Award className="h-8 w-8 text-primary" /> شاراتي
      </h1>
      {badges.length === 0 ? (
        <Card className="rounded-3xl border-dashed">
          <CardContent className="p-10 text-center">
            <p className="text-muted-foreground">لم تحصل على أي شارات بعد. استمر في التعلم!</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {badges.map((b, i) => (
            <Card
              key={i}
              className="rounded-2xl border-0 shadow-soft text-center hover:-translate-y-1 transition"
            >
              <CardContent className="p-6">
                <div className="text-5xl mb-3">{b.badges?.icon || "🏅"}</div>
                <h3 className="font-bold text-sm mb-1">{b.badges?.name}</h3>
                <p className="text-xs text-muted-foreground">
                  {new Date(b.earned_at).toLocaleDateString("ar-EG")}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
